import { render, staticRenderFns } from "./HeaderLayout.vue?vue&type=template&id=2f174368&scoped=true&lang=pug&"
import script from "./HeaderLayout.vue?vue&type=script&lang=js&"
export * from "./HeaderLayout.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLayout.vue?vue&type=style&index=0&id=2f174368&scoped=true&lang=css&"
import style1 from "./HeaderLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f174368",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/home/node/components/shared/Notification.vue').default,AvatarUsuario: require('/home/node/components/shared/AvatarUsuario.vue').default})
